module.exports = __webpack_public_path__ + "static/media/wicket5.e99f5389.png";